import './NCRForm.scss';

import React, { createContext, useEffect, useState } from 'react';

import { useParams, useLocation } from 'react-router-dom';
import { useForm, FormProvider } from 'react-hook-form';

import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import FormGroup from 'react-bootstrap/FormGroup';
import Row from 'react-bootstrap/Row';

import { Toast, Spinner } from 'components/layout';

import {
  AuditInformation,
  CorrectiveAction,
  FileAttachments,
  NCRDetail,
  OrderDetail,
  ReturnDetail,
  ReturnStatusArrows,
  ReturnSubmitButtons,
  StatusArrows,
  SubmitButtons,
} from 'components/form/sections';

import { cloneDeep } from 'lodash';
import axios from 'axios';

import baseState from 'utils/state';

const NCRContext = createContext(null);

const NCRForm = () => {
  const { id } = useParams();
  const formMethods = useForm();
  const location = useLocation();

  const [state, setState] = useState(cloneDeep(baseState));
  const [loading, setLoading] = useState(true);
  const [toasts, setToasts] = useState([]);

  const NCRContextValue = {
    state,
    setState,
    loading,
    setLoading,
    toasts,
    setToasts,
  };

  useEffect(() => {
    const fetchData = () => {
      const apiData = {};
      const promises = [
        { name: 'subsidiaries', call: axios.get('/api/subsidiary') },
        { name: 'users', call: axios.get('/api/users') },
        { name: 'reasons', call: axios.get('/api/reason') },
        { name: 'liabilities', call: axios.get('/api/liability') },
        { name: 'incoterms', call: axios.get('/api/incoterm') },
        { name: 'restock_charge', call: axios.get('/api/restock_charge') },
      ];
      id && promises.push({ name: 'ncr', call: axios.get(`/api/ncr/${id}`) });
      Promise.all(promises.map((p) => p.call)).then((allRes) => {
        allRes.forEach((res, index) => {
          apiData[promises[index].name] = res.data;
        });
        setState((prev) => ({ ...prev, ...apiData }));
        setLoading(false);
      });
    };

    fetchData();
  }, [id, state.ncr.amended_date]);

  if (location.pathname === '/create' || location.pathname.includes('/ncr')) {
    return (
      <NCRContext.Provider value={NCRContextValue}>
        {toasts.map((toast, idx) => (
          <Toast key={idx} {...toast} />
        ))}
        {loading ? (
          <Spinner size={150} />
        ) : (
          <Container fluid>
            <Row className={'m-auto text-center arrow-main-container'}>
              <StatusArrows />
            </Row>
            <Row>
              <Col>
                <h1 className={'text-center align-middle my-5'}>
                  Non-Conformance Form
                </h1>
              </Col>
            </Row>
            <Row className={'mb-2'}>
              <Col>
                <FormProvider {...formMethods}>
                  <Form>
                    <FormGroup>
                      <NCRDetail />
                      <OrderDetail />
                      <CorrectiveAction />
                      <FileAttachments />
                      <AuditInformation />
                    </FormGroup>
                    <SubmitButtons />
                  </Form>
                </FormProvider>
              </Col>
            </Row>
          </Container>
        )}
      </NCRContext.Provider>
    );
  } else if (
    location.pathname === '/create_return' ||
    location.pathname.includes('/return')
  ) {
    return (
      <NCRContext.Provider value={NCRContextValue}>
        {toasts.map((toast, idx) => (
          <Toast key={idx} {...toast} />
        ))}
        {loading ? (
          <Spinner size={150} />
        ) : (
          <Container fluid>
            <Row className={'m-auto text-center arrow-main-container'}>
              <ReturnStatusArrows />
            </Row>
            <Row>
              <Col>
                <h1 className={'text-center align-middle my-5'}>
                  Returns Form
                </h1>
              </Col>
            </Row>
            <Row className={'mb-2'}>
              <Col>
                <FormProvider {...formMethods}>
                  <Form>
                    <FormGroup>
                      <ReturnDetail />
                      <FileAttachments />
                      <AuditInformation />
                    </FormGroup>
                    <ReturnSubmitButtons />
                  </Form>
                </FormProvider>
              </Col>
            </Row>
          </Container>
        )}
      </NCRContext.Provider>
    );
  }
};

export { NCRForm, NCRContext };
